__webpack_require__.p = "/rubcube/";